module.exports = __webpack_public_path__ + "img/banner_check.d5d6a22a.svg";